import { render } from "./ScreenPortrait.vue?vue&type=template&id=6999170a&scoped=true"
import script from "./ScreenPortrait.vue?vue&type=script&lang=js"
export * from "./ScreenPortrait.vue?vue&type=script&lang=js"

import "./ScreenPortrait.vue?vue&type=style&index=0&id=6999170a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6999170a"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QChip,QIcon});
